import type { Theme } from "@emotion/react";
import { css } from "@emotion/react";

export const SENTRY_WIDGET_ID = "skilitics-designer-feedback";

export const globalStyles = (theme: Theme) => css`
  /*
  Changes the default CSS box model
  See https://css-tricks.com/box-sizing/
*/
  html {
    box-sizing: border-box;
    font-size: 14px;
  }
  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }

  * {
    scrollbar-width: thin;
  }

  /*
    Needed to disable browser level pinch to zoom
    so that we can supply our own zoom handler and restrict it to the canvas
  */
  html,
  body {
    touch-action: none;
    overscroll-behavior: none;
  }
  ::selection,
  ::-moz-selection {
    background: ${theme.primary};
    color: ${theme.onPrimary};
  }
  :focus-visible {
    outline: none;
  }

  /*
    CSS solution to propagate target of click handlers to the button, instead of contents of the button.
  */
  button > * {
    pointer-events: none;
  }

  pre {
    max-width: 100%;
    white-space: normal;
  }

  ${css(theme.global)}

  body {
    margin: 0;

    font-family: ${theme.fontFamily};
    font-size: ${theme.fontSize};

    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  button,
  input,
  textarea {
    font-family: inherit;
  }

  ul {
    margin-block: 5px;
    padding-inline-start: 20px;
  }

  @keyframes pop {
    0% {
      transform: scale(1);
      box-shadow: var(--box-shadow);
    }
    100% {
      transform: scale(var(--scale));
      box-shadow: var(--box-shadow-picked-up);
    }
  }

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  @keyframes fadeInOut {
    0% {
      opacity: 0;
    }
    33% {
      opacity: 1;
    }
    0% {
      opacity: 0;
    }
  }

  // Toast Styles
  .toast-content {
    max-width: 400px;
    > div + div {
      max-height: 300px;
      overflow-y: auto;
      justify-content: flex-start;
    }
  }

  // Sentry Feedback Widget
  #${SENTRY_WIDGET_ID} {
    --accent-background: ${theme.primary};
    --accent-foreground: ${theme.onPrimary};
    --font-family: ${theme.fontFamily};
    --foreground: ${theme.generalTextIcon};
    --background: ${theme.surface};
    --border: solid 1px ${theme.outlineSoft};
    --dialog-border-radius: 5px;
  }
`;
